import HttpService from "@core/services/http/http.service";
import { LoginInitialValues, LoginResponse } from "@app/types";

class _AuthService {
  public login(body: LoginInitialValues) {
    return HttpService.post<LoginResponse>("/auth/login", {
      body: { ...body },
    });
  }

  public verifyToken() {
    return HttpService.get<any>("/auth/verify-token");
  }

  public changePassword(body: { oldPassword: string; password: string }) {
    return HttpService.post<any>("/auth/change-password", {
      body: { ...body },
    });
  }
}

const AuthService = new _AuthService();

export default AuthService;
